// ======================================================================================================================= 1
// gsap.set('.co-learn-1-image', {
//   top: "-10%"
// });
gsap.to('.co-learn-1-image-bg', {
    scrollTrigger: {
        // markers: true,
        trigger: '.co-learn-1',
        start: 'top top',
        end: 'bottom top',
        scrub: 1
    },
    scale: 1.2
});
// ======================================================================================================================= 5
gsap.registerPlugin(MotionPathPlugin);
const coH7ScrollTRIGGER = '.co-learn-5-bee-start-trigger';
const coH7ScrollTRIGGEREND = '.co-learn-5-bee-end-trigger'
const coH7ScrollSTART = 'top bottom';
const coH7ScrollEND = 'bottom top';
function getUpdatedMotionPath() {
  return {
    markers: true,
    immediateRender: true,
    path: "#co-svg-home-9-motion-path-id",
    align: "#co-svg-home-9-motion-path-id",
    // autoRotate: true,
    alignOrigin: [0.5, 0.5],
    start: 1,
    end: 0,
  };
}
function initializeMotionPath() {
  gsap.set('.co-learn-5-bee-layer-1', { rotateX: 360, opacity: 1 });
  const coHomeSection2MotionPath = getUpdatedMotionPath();
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREND,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: 1,
    },
  });
  tl.to('.co-learn-5-bee', {
    motionPath: coHomeSection2MotionPath,
  });  
  ScrollTrigger.create({
    trigger: coH7ScrollTRIGGER,
    endTrigger: coH7ScrollTRIGGEREND,
    start: coH7ScrollSTART,
    end: coH7ScrollEND,
    onUpdate: (self) => {
      self.direction === -1 ? coMotionPathFlipLeft() : coMotionPathFlipRight();
    },
  });
}
function coMotionPathFlipRight() {
  gsap.to(".co-learn-5-bee-layer-2", { rotateY: 180, duration: 0.1 });
}
function coMotionPathFlipLeft() {
  gsap.to(".co-learn-5-bee-layer-2", { rotateY: 0, duration: 0.1 });
}
initializeMotionPath();
window.addEventListener('resize', () => {
  initializeMotionPath();
  ScrollTrigger.refresh();
});
// ======================================================================================================================= 8
// gsap.to('.co-learn-8-video', {
//     scrollTrigger: {
//         // markers: true,
//         trigger: '.co-learn-8-video',
//         start: 'bottom bottom',
//         end: 'top top',
//         scrub: 1
//     },
//     width: '100%'
// });
// gsap.to('.co-learn-8-video-layer', {
//     scrollTrigger: {
//         // markers: true,
//         trigger: '.co-learn-8-video',
//         start: 'bottom bottom',
//         end: 'top top',
//         scrub: 1
//     },
//     width: '100%',
//     height: '100%'
// })